import { State } from "xstate";
import { getDayColourOptions, productHasColour } from "./colour";
import { productHasVariantWithMaterialType } from "./material";
import {
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema,
  } from '../types';

type GetDayColourSwatchUrl = (
    state: State<
      ProductBuilderMachineContext,
      ProductBuilderMachineEvent,
      ProductBuilderMachineStateSchema
    >,
  ) => string;

export const getDayColourSwatchUrl: GetDayColourSwatchUrl = state => {

const colourOptions = getDayColourOptions(
    state.context.products
      .filter(
        productHasVariantWithMaterialType(state.context.custom.materialType),
      )
      .filter(productHasColour(state.context.custom.colourNight)),
  );

  let dayColour = colourOptions.find(
    colour => colour.name === state.context.custom.dayColour,
  );

  let dayFill =
    dayColour &&
    state.context.custom.cellDesign &&
    state.context.custom.cellDesign.includes('45')
      ? dayColour['45mm_swatch_url']
      : dayColour && dayColour['25mm_swatch_url']
      ? dayColour['25mm_swatch_url']
      : 'https://cdn.shopify.com/s/files/1/0283/1053/6227/products/25-Cloud-White.png?v=1611122967';

    return dayFill;

};
